import { ApiPrivateDocumentDto } from '@/shared/api';
import { generateDtoId } from '@/shared/lib/sj-orm/helpers';
import { DocumentType } from '@/shared/lib/sj-orm/models/document/document-base.dto';
import { PrivateDocumentDto } from '@/shared/lib/sj-orm/models/document/private.document.dto';
import { CollectionName } from '@/shared/lib/sj-orm/types';
import { AIStatus } from '@/shared/types';

import { getValidPrivateDocument } from '../validator';

export const makePrivateDoc = (
  aiProps: {
    aiStatus: AIStatus;
  },
  privateDocument: ApiPrivateDocumentDto,
) => {
  let newDocument: PrivateDocumentDto | null = null;
  if (privateDocument?.privateCategory === undefined) return newDocument;

  const privateDocumentData = getValidPrivateDocument({
    data: privateDocument,
    privateCategory: privateDocument.privateCategory,
  });

  if (!privateDocumentData) return newDocument;
  newDocument = {
    id: generateDtoId(CollectionName.PRIVATE_DOCUMENTS),
    ...privateDocumentData,
    ...aiProps,
    type: DocumentType.PRIVATE_DOCUMENTS,
  };

  return newDocument;
};
